import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { css } from '@emotion/core';

import config from 'config';

const table = css`
    tbody td,
    tfoot td {
        padding-top: ${config('/tailwind/padding/2')};
        padding-bottom: ${config('/tailwind/padding/2')};
        padding-right: ${config('/tailwind/padding/4')};
        padding-left: ${config('/tailwind/padding/4')};
    }

    tbody tr:first-of-type td,
    tfoot td {
        padding-top: ${config('/tailwind/padding/6')};
    }

    tbody tr:last-child td {
        padding-bottom: ${config('/tailwind/padding/6')};
    }

    @media (min-width: ${config('/tailwind/screens/md/min')}) {
        tbody td,
        tfoot td {
            padding-top: ${config('/tailwind/padding/3')};
            padding-bottom: ${config('/tailwind/padding/3')};
        }

        tbody tr:first-of-type td,
        tfoot td {
            padding-top: ${config('/tailwind/padding/8')};
        }

        tbody tr:last-child td {
            padding-bottom: ${config('/tailwind/padding/8')};
        }
    }
`;

const AmountTable = ({
    showPerformanceColumn,
    showTotal,
    data,
    descriptionLabel,
    performanceLabel,
    amountLabel,
    totalLabel,
    totalValue,
}) => (
    <table className="w-full border-collapse text-gray-70" css={table}>
        <thead className="text-12 font-bold">
            <tr>
                <th scope="col" className="bg-gray-20 rounded-l py-2 px-4 text-left">
                    {descriptionLabel}
                </th>
                {showPerformanceColumn && (
                    <th
                        scope="col"
                        className={cx('bg-gray-20 py-2 px-4 text-center', {
                            'w-1/4': showPerformanceColumn,
                            'w-1/3': !showPerformanceColumn,
                        })}
                    >
                        {performanceLabel}
                    </th>
                )}
                <th
                    scope="col"
                    className={cx('bg-gray-20 py-2 px-4 rounded-r text-right', {
                        'w-1/4': showPerformanceColumn,
                        'w-1/3': !showPerformanceColumn,
                    })}
                >
                    {amountLabel}
                </th>
            </tr>
        </thead>
        <tbody className="mt-8">
            {data.map(line => (
                <tr
                    key={line.label}
                    className={cx('transition', { 'text-gray-30 lg:text-gray-20': line.muted })}
                >
                    <td className="text-left">{line.label}</td>
                    {showPerformanceColumn && <td className="text-center">{line.performance}</td>}
                    <td className="text-right">{line.amount}</td>
                </tr>
            ))}
        </tbody>
        {showTotal && (
            <tfoot className="font-bold border-t border-gray-30 lg:border-gray-20 text-18">
                <tr>
                    <td className="text-left">{totalLabel}</td>
                    <td className="text-right">{totalValue}</td>
                </tr>
            </tfoot>
        )}
    </table>
);

AmountTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            performance: PropTypes.string,
            amount: PropTypes.string.isRequired,
            muted: PropTypes.bool,
        })
    ).isRequired,
    showPerformanceColumn: PropTypes.bool,
    showTotal: PropTypes.bool,
    descriptionLabel: PropTypes.string,
    performanceLabel: PropTypes.string,
    amountLabel: PropTypes.string,
    totalLabel: PropTypes.string,
    totalValue: PropTypes.string,
};

AmountTable.defaultProps = {
    showPerformanceColumn: false,
    showTotal: false,
    descriptionLabel: 'Description',
    performanceLabel: '',
    amountLabel: 'Est. Amount',
    totalLabel: 'Est. Total',
    totalValue: '',
};

export default AmountTable;
